import React, { useState, useEffect } from "react";
import CurrencyDropDown from "./DropDown/CurrencyDropDown";
import MaterialDropDown from "./DropDown/MaterialDropDown";
import WeightDropDown from "./DropDown/WeightDropDown";

const Ticker = (props) => {
  const {
    defaultValue,
    items: propItems,
    title,
    page,
    defaultWeight,
    currencyVal,
    defaultCurrency,
  } = props;
  let arrow = "";
  let sign = "";
  let colour = "";

  const [item, setItem] = useState(null);
  const [difference, setDifference] = useState("");
  const [percent, setPercent] = useState("");
  const [arrowDiff, setArrowDiff] = useState(null);
  const [currency, setCurrency] = useState("USD");
  const [value, setValue] = useState("");
  const [previousValue, setPreviousValue] = useState("");
  const [currentWeight, setCurrentweight] = useState(null);
  const [previousWeight, setPreviousWeight] = useState(null);
  const [items, setItems] = useState(propItems);
  const { xauPrice, xauClose, pcXau, xagPrice, xagClose, pcXag } = items;

  const getLocal = (prop) => {
    return JSON.parse(localStorage.getItem(prop));
  };

  useEffect(() => {
    setItems(propItems);
    setValue(defaultValue);
    setCurrency(defaultCurrency);
    if (
      getLocal(`${title}_${page}`) &&
      getLocal(`${title}_${page}`).weight_ticker
    ) {
      setCurrentweight(getLocal(`${title}_${page}`).weight_ticker);
    }
    if (
      getLocal(`${title}_${page}`) &&
      getLocal(`${title}_${page}`).material_ticker
    ) {
      setValue(getLocal(`${title}_${page}`).material_ticker);
    }
    
    if (value === "Gold") {
      if (previousWeight === null) {
        setItem(xauPrice.toFixed(2));
        setArrowDiff(xauClose.toFixed(2));
      }
      if (currentWeight === "o") {
        setItem(xauPrice.toFixed(2));
        setArrowDiff(xauClose.toFixed(2));
      } else if (currentWeight === "g" || defaultWeight === "g") {
        setItem((xauPrice / 31.1034768).toFixed(2));
        setArrowDiff((xauClose / 31.1034768).toFixed(2));
      } else if (currentWeight === "k" || defaultWeight === "k") {
        setItem((xauPrice * 32.1507466).toFixed(2));
        setArrowDiff((xauClose * 32.1507466).toFixed(2));
      }
      setDifference((item - arrowDiff).toFixed(2));
      setPercent(pcXau.toFixed(2));
    }
    if (value === "Silver") {
      if (previousWeight === null) {
        setItem(xagPrice.toFixed(2));
        setArrowDiff(xagClose.toFixed(2));
      }
      if (currentWeight === "o") {
        setItem(xagPrice.toFixed(2));
        setArrowDiff(xagClose.toFixed(2));
      } else if (currentWeight === "g") {
        setItem(xagPrice.toFixed(2));
        setArrowDiff(xagClose.toFixed(2));
      } else if (currentWeight === "k" || defaultWeight === "k") {
        setItem((xagPrice * 32.1507466).toFixed(2));
        setArrowDiff((xagClose * 32.1507466).toFixed(2));
      }
      setDifference((item - arrowDiff).toFixed(2));
      setPercent(pcXag.toFixed(2));
    }
  }, [props, value, previousWeight, currentWeight, item, arrowDiff, items]);

  if (item && arrowDiff && item >= arrowDiff) {
    arrow = "arrow-up";
    sign = "+";
    colour = "green";
    if (difference < 0) {
      arrow = "arrow-down";
      sign = "";
      colour = "red";
    }
  } else {
    arrow = "arrow-down";
    sign = "";
    colour = "red";
  }

  const updateUrl = async (val) => {
    await fetch(`https://data-asg.goldprice.org/dbXRates/${val}`)
      .then((res) => res.json())
      .then((result) => {
        // this.setState({
        //   items: result.items[0]
        // });
        console.log("result.items[0]", result.items[0]);
        setItems(result.items[0]);
      });
  };

  function handleMaterialChange(val) {
    setValue(val);
    updateLocalStorage({ name: "material_ticker", value: val });
  }

  function handleCurrencyChange(val) {
    setCurrency(val);
    currencyVal(val);
    updateUrl(val);
    updateLocalStorage({ name: "currency_ticker", value: val });
  }

  function getValue(val) {
    setPreviousValue(val);
  }

  function handleWeightChange(val) {
    setCurrentweight(val);
    setPreviousWeight(previousValue);
    updateLocalStorage({ name: "weight_ticker", value: val });
  }

  //set and update the local storage
  function updateLocalStorage(payload) {
    let chartType = `${title}`;
    const { name = "", value = "" } = payload;
    let existingValue = localStorage.getItem(`${chartType}_${page}`)
      ? getLocal(`${chartType}_${page}`)
      : {};

    let updatedValues = { ...existingValue, [name]: value };
    localStorage.setItem(`${chartType}_${page}`, JSON.stringify(updatedValues));
  }

  function getChartPropertiesFromLocalStorage() {
    return localStorage.getItem(`${title}_${page}`)
      ? getLocal(`${title}_${page}`)
      : {};
  }

  const {
    material_ticker = null,
    currency_ticker = null,
    weight_ticker = null,
  } = getChartPropertiesFromLocalStorage();
  const val = parseFloat(item).toLocaleString();
  return (
    <div>
      <div className="tick-value-wrap d-flex align-items-center justify-content-center flex-wrap">
        <div className="tick-value price-value">
          <span className="gpoticker-price">{val}</span>
        </div>
        <div className="tick-value price_arrow">
          <div className={arrow}></div>
        </div>
        <div className={`tick-value price-chg ${colour}`}>
          <span className="gpoticker-price">
            {sign}
            {difference}
          </span>
        </div>
        <div className={`tick-value price-pc ${colour}`}>
          <span className="gpoticker-price">
            {sign}
            {percent}%
          </span>
        </div>
      </div>
      <div className="select-wrapper">
        <form className="text-center">
          <MaterialDropDown
            title="Ticker"
            defaultValue={material_ticker ? material_ticker : defaultValue}
            handleChange={handleMaterialChange}
            previousValue={getValue}
          />
          <CurrencyDropDown
            defaultCurrency={
              currency_ticker ? currency_ticker : defaultCurrency
            }
            handleChange={handleCurrencyChange}
            previousValue={getValue}
          />
          <WeightDropDown
            defaultWeight={weight_ticker ? weight_ticker : defaultWeight}
            tickerTitle={title}
            url={material_ticker ? material_ticker : defaultValue}
            handleChange={handleWeightChange}
            previousValue={getValue}
          />
        </form>
      </div>
    </div>
  );
};

export default Ticker;
